import React from "react"
import PropTypes from "prop-types"
import { useEditing } from "app/regions/hooks/use-editing"

/**
 * Clicks the button with the matching `data-image-uploader` attribute. This
 * works in tandem with the `ImageUploader` component.
 *
 * @param {String} name
 */

function click(name) {
  const el = document.querySelector(`[data-image-uploader='${name}']`)
  if (el?.tagName === "BUTTON") el.click()
}

export function EditableImage({ name, src, alt = "", ...props }) {
  const editing = useEditing()

  const excludeMSO = `
  <!--[if !mso]><!-->`

  const msoImage = `
  <!--<![endif]-->
  <!--[if mso]>
  <img width="200" src="${src}" alt="${alt}">
  <![endif]-->
  `
  return (
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    <>
      <div dangerouslySetInnerHTML={{ __html: excludeMSO }} />
      <img
        alt={alt}
        role={editing ? "button" : null}
        tabIndex={editing ? 0 : null}
        onClick={() => click(name)}
        onKeyDown={() => click(name)}
        src={src}
        {...props}
      />
      <div dangerouslySetInnerHTML={{ __html: msoImage }} />
    </>
  )
}

EditableImage.propTypes = {
  name: PropTypes.string.isRequired,
  alt: PropTypes.string,
  src: PropTypes.string
}

